/* @jsx jsx */
/** @jsxfrag */
import React, { Fragment } from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import LegacyButton from '@atlaskit/button/standard-button';
import { IconButton } from '@atlaskit/button/new';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { Inline } from '@atlaskit/primitives';
import LikeIcon from '@atlaskit/icon/glyph/like';
import Lozenge from '@atlaskit/lozenge';
import { N100 } from '@atlaskit/theme/colors';
import messages from './messages';
import { buttonGroupStyles, dislikeButtonStyles } from './styles';
export const FeedbackForm = ({
  onGoodResponseButtonClick,
  onBadResponseButtonClick,
  tabIndex
}) => {
  const {
    formatMessage
  } = useIntl();
  const feedbackWasSentLabel = formatMessage(messages.feedbackSent);
  const goodResponseLabel = formatMessage(messages.goodResponse);
  const badResponseLabel = formatMessage(messages.badResponse);
  const [isFeedbackDisabled, setIsFeedbackDisabled] = React.useState(false);
  const iconColor = `var(--ds-icon, ${N100})`;
  const handleOnClick = React.useCallback(onClick => () => {
    onClick();
    setIsFeedbackDisabled(true);
  }, []);
  const likeButton = () => jsx(LikeIcon, {
    label: goodResponseLabel,
    primaryColor: iconColor
  });
  return jsx("div", {
    css: buttonGroupStyles
  }, isFeedbackDisabled && jsx("p", {
    "aria-atomic": "false",
    "aria-live": "polite"
  }, jsx(Lozenge, {
    appearance: "success",
    testId: "feedback-success"
  }, feedbackWasSentLabel)), getBooleanFF('platform.design-system-team.editor-new-button_jjjdo') ? jsx(Inline, {
    space: "space.100"
  }, jsx(Tooltip, {
    content: goodResponseLabel,
    position: "top"
  }, jsx(IconButton, {
    testId: "good-response-feedback-button",
    type: "button",
    isDisabled: isFeedbackDisabled,
    onClick: handleOnClick(onGoodResponseButtonClick),
    icon: likeButton,
    label: goodResponseLabel,
    appearance: "subtle",
    tabIndex: tabIndex,
    spacing: "compact"
  })), jsx(Tooltip, {
    content: badResponseLabel,
    position: "top"
  }, jsx("div", {
    css: dislikeButtonStyles
  }, jsx(IconButton, {
    testId: "bad-response-feedback-button",
    type: "button",
    isDisabled: isFeedbackDisabled,
    onClick: handleOnClick(onBadResponseButtonClick),
    icon: likeButton,
    label: badResponseLabel,
    appearance: "subtle",
    tabIndex: tabIndex,
    spacing: "compact"
  })))) : jsx(Fragment, null, jsx(Tooltip, {
    content: goodResponseLabel,
    position: "top"
  }, jsx(LegacyButton, {
    "aria-label": goodResponseLabel,
    testId: "good-response-feedback-button",
    type: "button",
    isDisabled: isFeedbackDisabled,
    onClick: handleOnClick(onGoodResponseButtonClick),
    iconBefore: jsx(LikeIcon, {
      label: goodResponseLabel,
      primaryColor: iconColor
    }),
    appearance: "subtle",
    tabIndex: tabIndex,
    spacing: "compact"
  })), jsx(Tooltip, {
    content: badResponseLabel,
    position: "top"
  }, jsx(LegacyButton, {
    css: dislikeButtonStyles,
    "aria-label": badResponseLabel,
    testId: "bad-response-feedback-button",
    type: "button",
    isDisabled: isFeedbackDisabled,
    onClick: handleOnClick(onBadResponseButtonClick),
    iconBefore: jsx(LikeIcon, {
      label: badResponseLabel,
      primaryColor: iconColor
    }),
    appearance: "subtle",
    tabIndex: tabIndex,
    spacing: "compact"
  }))));
};